import React, { useContext, useState } from "react";
import { Box, Button, CircularProgress, FormControl, Paper, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import logo from "../../Assets/logo.png";
import { SnackBarContext } from "../../Context/SnackBarContext/SnackBarContext";
import { ResetPasswordApi } from "../../Api/ResetPasswordApi/ResetPasswordApi";

const useStyle = makeStyles(theme => ({
  Container: {
    display: "flex",
    width: "100%",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
  },
  resetBox: {
    width: "100%",
    maxWidth: "450px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  imgBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "10px",
  },
  paperBox: {
    width: "100%",
    padding: "20px",
    display: "flex",
    gap: "20px",
    flexDirection: "column",
  },
  resetBtn: {
    width: "100%",
    backgroundColor: theme.palette.primary.main,
    textTransform: "capitalize",
    color: "white",
    "&:hover": {
      opacity: theme.palette.action.hoverOpacity,
    },
  },
}));

function ResetPassword() {
  const classes = useStyle();
  const navigate = useNavigate();
  const { setsnackBarData } = useContext(SnackBarContext);

  const location = useLocation();

  const email = location?.state?.email;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // safety check
  if (!email) {
    navigate("/");
  }

  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object({
    password: Yup.string().required("Please enter new password").min(8, "Password must be at least 8 characters"),
    confirmPassword: Yup.string()
      .required("Please confirm password")
      .oneOf([Yup.ref("password")], "Passwords do not match"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,

    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        setSubmitting(true);

        const payload = {
          email: email,
          password: values.password,
          confirmPassword: values.confirmPassword,
        };

        const response = await ResetPasswordApi(payload);

        setsnackBarData({
          openToast: true,
          type: response?.data?.IsSuccess ? "success" : "error",
          message: response?.data?.Message,
        });

        if (response?.data?.IsSuccess) {
          resetForm();
          navigate("/");
        }
      } catch (error) {
        setsnackBarData({
          openToast: true,
          type: "error",
          message: error?.response?.data?.Message || "Something went wrong",
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Box className={classes.Container}>
      <Box className={classes.resetBox}>
        {/* LOGO */}
        <Box className={classes.imgBox}>
          <img src={logo} alt="logo" style={{ width: "200px" }} />
          <Typography sx={{ color: theme => theme.palette.grey[700] }}>One Perfect Solution</Typography>
        </Box>

        <Paper elevation={3} sx={{ padding: "30px 20px" }}>
          <form onSubmit={formik.handleSubmit}>
            <Box className={classes.paperBox}>
              <Typography variant="h5" fontWeight="bold">
                Reset Password
              </Typography>

              {/* PASSWORD */}
              <FormControl fullWidth>
                <Typography>New Password</Typography>
                <TextField
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.password && Boolean(formik.errors.password)}
                  helperText={formik.touched.password && formik.errors.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(prev => !prev)}>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              {/* CONFIRM PASSWORD */}
              <FormControl fullWidth>
                <Typography>Confirm Password</Typography>
                <TextField
                  name="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                  helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowConfirmPassword(prev => !prev)}>
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              {formik.isSubmitting ? (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <CircularProgress size={25} />
                </Box>
              ) : (
                <Button type="submit" variant="contained">
                  Reset Password
                </Button>
              )}
            </Box>
          </form>
        </Paper>
      </Box>
    </Box>
  );
}

export default ResetPassword;

// import React, { useContext, useState } from "react";
// import { Box, Button, CircularProgress, FormControl, Paper, TextField, Typography } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useLocation, useNavigate } from "react-router-dom";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import InputAdornment from "@mui/material/InputAdornment";
// import IconButton from "@mui/material/IconButton";
// import logo from "../../Assets/logo.png";
// import { SnackBarContext } from "../../Context/SnackBarContext/SnackBarContext";
// import { ResetPasswordApi } from "../../Api/ResetPasswordApi/ResetPasswordApi";

// const useStyle = makeStyles(theme => ({
//   Container: {
//     display: "flex",
//     width: "100%",
//     height: "100vh",
//     justifyContent: "center",
//     alignItems: "center",
//   },

//   resetBox: {
//     width: "100%",
//     maxWidth: "450px",
//     display: "flex",
//     flexDirection: "column",
//     gap: "20px",
//   },

//   imgBox: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     padding: "10px",
//   },

//   paperBox: {
//     width: "100%",
//     padding: "20px",
//     display: "flex",
//     gap: "20px",
//     flexDirection: "column",
//   },

//   resetBtn: {
//     width: "100%",
//     backgroundColor: theme.palette.primary.main,
//     textTransform: "capitalize",
//     color: "white",
//     "&:hover": {
//       opacity: theme.palette.action.hoverOpacity,
//     },
//   },
// }));

// function ResetPassword() {
//   const classes = useStyle();
//   const navigate = useNavigate();
//   const { setsnackBarData } = useContext(SnackBarContext);

//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const email = queryParams.get("Email");
//   let code = queryParams.get("Code");
//   if (code) {
//     code = code.replace(/ /g, "+");
//   }
//   // console.log("EMAIL =>", email);
//   // console.log("CODE =>", code);

//   const initialValues = {
//     password: "",
//     confirmPassword: "",
//   };

//   const validationSchema = Yup.object({
//     password: Yup.string().required("Please enter new password").min(8, "Password must be at least 8 characters"),
//     confirmPassword: Yup.string()
//       .required("Please confirm password")
//       .oneOf([Yup.ref("password")], "Passwords do not match"),
//   });

//   const formik = useFormik({
//     initialValues,
//     validationSchema,
//     onSubmit: async (values, { setSubmitting, resetForm }) => {
//       try {
//         setSubmitting(true);

//         const payload = {
//           email,
//           code,
//           password: values.password,
//           confirmPassword: values.confirmPassword,
//         };

//         const response = await ResetPasswordApi(payload);

//         setsnackBarData({
//           openToast: true,
//           type: response?.data?.IsSuccess ? "success" : "error",
//           message: response?.data?.Message || "Password reset successfully",
//         });

//         if (response?.data?.IsSuccess) {
//           resetForm();
//           navigate("/");
//         }
//       } catch (error) {
//         setsnackBarData({
//           openToast: true,
//           type: "error",
//           message: error?.response?.data?.Message || "Something went wrong",
//         });
//       } finally {
//         setSubmitting(false);
//       }
//     },
//   });

//   return (
//     <Box className={classes.Container}>
//       <Box className={classes.resetBox}>
//         {/* Logo */}
//         <Box className={classes.imgBox}>
//           <img src={logo} alt="logo" style={{ width: "200px" }} />
//           <Typography sx={{ color: theme => theme.palette.grey[700] }}>One Perfect Solution</Typography>
//         </Box>

//         {/* Card */}
//         <Paper elevation={3} sx={{ padding: "30px 20px" }}>
//           <form onSubmit={formik.handleSubmit}>
//             <Box className={classes.paperBox}>
//               <Typography variant="h5" sx={{ fontWeight: "bold", color: theme => theme.palette.grey[800] }}>
//                 Reset Password
//               </Typography>

//               {/* Password */}
//               <FormControl fullWidth>
//                 <Typography>New Password</Typography>
//                 <TextField
//                   name="password"
//                   type={showPassword ? "text" : "password"}
//                   value={formik.values.password}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.password && Boolean(formik.errors.password)}
//                   helperText={formik.touched.password && formik.errors.password}
//                   InputProps={{
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <IconButton onClick={() => setShowPassword(prev => !prev)} edge="end">
//                           {showPassword ? <VisibilityOff /> : <Visibility />}
//                         </IconButton>
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </FormControl>

//               {/* Confirm Password */}
//               <FormControl fullWidth>
//                 <Typography>Confirm Password</Typography>
//                 <TextField
//                   name="confirmPassword"
//                   type={showConfirmPassword ? "text" : "password"}
//                   value={formik.values.confirmPassword}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
//                   helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
//                   InputProps={{
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <IconButton onClick={() => setShowConfirmPassword(prev => !prev)} edge="end">
//                           {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                         </IconButton>
//                       </InputAdornment>
//                     ),
//                   }}
//                 />
//               </FormControl>

//               {/* Button */}
//               {formik.isSubmitting ? (
//                 <CircularProgress size={25} />
//               ) : (
//                 <Button type="submit" variant="contained">
//                   Reset Password
//                 </Button>
//               )}
//             </Box>
//           </form>
//         </Paper>
//       </Box>
//     </Box>
//   );
// }

// export default ResetPassword;
